import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { VersionResponse } from '../../shared/models/version.model';

@Injectable({ providedIn: 'root' })
export class VersionApiService {
  private http = inject(HttpClient);
  private baseUri = `${environment.apiBaseUrl}/version`;

  public getVersion(): Observable<VersionResponse> {
    return this.http.get<VersionResponse>(this.baseUri);
  }
}
